import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { iconColor } from 'utils/helpers'

interface IClose {
  white?: boolean
  black?: boolean
  red?: boolean
  onClick?: any
}

export const CloseIcon = ({ onClick }: IClose) => {

  const { darkMode } = useSelector((state: RootState) => state.globals)
  const stroke = iconColor(darkMode)


  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} style={{ cursor: 'pointer' }}>
      <path d="M18 6L6 18" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 6L18 18" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
